/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import Breadkrumbs from "./Breadkrumbs";
import Carousel from "./Carousel";
import PropertyInfoCard from "./PropertyInfoCard";
import AboutPropertyAndLocation from "./AboutPropertyAndLocation";
import Amenities from "./Amenities";
// import Approvals from "./Approvals";
import BeegruScore from "./BeegruScore";
import Gmap from "./Gmap";
import EMICalculator from "./EMICalculator";
import AboutBuilder from "./AboutBuilder";
import Vicinity from "./Vicinity";
import LetUsHelpYouForm from "./LetUsHelpYouForm";
import ShareModal from "../../modals/ShareModal";
import ReportModal from "../../modals/ReportModal";
import FeaturedProperties from "./FeaturedProperties";

/* Library Imports */

import preparePriceString from "../../../lib/PreparePriceString";
import prepareAreaString from "../../../lib/PrepareAreaString";
import GetConfigIcon from "../../../lib/GetConfigIcon";

/* Redux imports */
import { connect } from "react-redux";
import { fetchSingleProperty } from "../../redux-components/Actions";

/* Data Imports */

import AppConfig from "../../../AppConfig";
import DownloadModal from "../../modals/DownloadModal";

const useStyles = makeStyles((theme) => ({
  sectionSplitter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
  },
  propertyData: {
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  propertyDataPdf: {
    width: "100%",
  },
  helpForm: {
    width: "30%",
    padding: "0rem 0rem 0rem 1rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  imageShowdown: {
    borderRadius: "4px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    margin: "0.5rem 0rem 0.5rem 0rem",
  },
  imageShowdownFirst: {
    borderRadius: "4px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    margin: "0rem 0rem 1rem 0rem",
  },
  imageShowdownLast: {
    borderRadius: "4px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    margin: "1rem 0rem 2rem 0rem",
  },
}));

const SPPContainer = (props) => {
  const classes = useStyles();

  const [openShare, setOpenShare] = React.useState(false);
  const [openReport, setOpenReport] = React.useState(false);
  const [openDownload, setOpenDownload] = React.useState(false);
  const [slug, setSlug] = React.useState(undefined);

  const [property, setProperty] = React.useState(props.defaultPropertyData);
  const [featuredProperties, setFeaturedProperties] = React.useState(
    props.defaultFeaturedPropertiesData
  );
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    props.fetchSingleProperty(
      props.currentSlug,
      (data) => {
        setProperty(data.property);
        setFeaturedProperties(data.featured);
        setSlug(data.property.slug);
        setLoading(false);
      },
      (error) => {
        setProperty(props.defaultPropertyData);
        setFeaturedProperties(props.defaultFeaturedPropertiesData);
        setSlug(props.defaultPropertyData.slug);
        setLoading(false);
      }
    );
  }, []);

  React.useEffect(() => {
    window.addEventListener("hashchange", hashListener);
  }, []);
  function hashListener() {
    setSlug(window.location.hash.split("-").slice(1).join("-"));
    if (window.location.hash.substring(0, 6) == "#share") {
      setOpenShare(true);
    } else if (window.location.hash.substring(0, 7) == "#report") {
      setOpenReport(true);
    }
  }

  const handleDownloadOpen = (event) => {
    setOpenDownload(true);
  };

  const handleClose = () => {
    setOpenShare(false);
    setOpenReport(false);
    setOpenDownload(false);
    window.location.hash = "";
  };

  return (
    <React.Fragment>
      <ShareModal
        open={openShare}
        onClose={handleClose}
        url={AppConfig.urlPrefix + "properties/" + slug}
      />
      <ReportModal
        open={openReport}
        onClose={handleClose}
        source={"report-property/" + slug}
      />
      <DownloadModal
        title={property.title}
        pdfHref={property.pdf}
        open={openDownload}
        onClose={handleClose}
        url={AppConfig.urlPrefix + "properties/" + slug}
        source={"download-pdf/" + property.slug}
        usePDFGenerator={property.pdf === "false"}
        slug={slug}
        mandate={property.mandate}
      />
      {!props.hideBreadCrumbs ? (
        <Breadkrumbs
          c="bengaluru"
          t="residential"
          slug={property.slug}
          location={property.location.title}
          title={property.title}
        />
      ) : undefined}
      {!props.hideCarousel ? (
        <Carousel images={property.images} loading={loading} />
      ) : undefined}
      {props.hideBreadCrumbs ? (
        <div style={{ height: "2rem" }}></div>
      ) : undefined}
      <PropertyInfoCard
        hideButtons={props.hideButtons}
        slug={property.slug}
        title={property.title}
        location={property.location.title}
        builder={property.builder.name}
        price={preparePriceString(property.price)}
        unitIcon={GetConfigIcon(property.tags)}
        area={prepareAreaString(property.area, "built_up_area", "ft")}
        chips={property.tags}
        description={property.short_description}
        config={property.bhk.label}
        bhk={property.bhk}
        pdfHref={property.pdf}
        pdfButtonClickListener={handleDownloadOpen}
        loading={loading}
      />
      {props.hideCarousel ? (
        <center>
          {property.images.map((image, key) => {
            return !image.video ? (
              <img
                key={key}
                src={image.url}
                width="745.92px"
                height="419.58px"
                loading="eager"
                className={
                  key == 0
                    ? classes.imageShowdownFirst
                    : key == property.images.filter((i) => !i.video).length - 1
                    ? classes.imageShowdownLast
                    : classes.imageShowdown
                }
              />
            ) : undefined;
          })}
        </center>
      ) : undefined}
      <div className={classes.sectionSplitter}>
        <div
          className={
            !props.hideHelpForm ? classes.propertyData : classes.propertyDataPdf
          }
        >
          <AboutPropertyAndLocation
            aboutProperty={property.about_property}
            aboutLocation={property.about_location}
            loading={loading}
          />
          <Amenities amenities={property.amenities} loading={loading} />
          {/* <Approvals
              approvals={[
                {
                  id: "club_house",
                  icon: "amenities/club",
                },
                {
                  id: "meditation hall",
                  icon: "amenities/meditation",
                },
                {
                  id: "jacuzzi",
                  icon: "amenities/jacuzzi",
                },
              ]}
            /> */}
          {property.mandate ? (
            <BeegruScore values={property.beegru_score} loading={loading} />
          ) : undefined}
          <AboutBuilder
            builderName={property.builder.name}
            builderLogo={property.builder.logo.url}
            builderProjects={property.builder.total_projects}
            builderEst={property.builder.year_est}
            builderDescription={property.builder.description}
            loading={loading}
          />
          <Gmap src={property.gmaps_embed_url} loading={loading} />
          {!props.hideEmiCalculator ? (
            <EMICalculator
              defaultLoanAmount={property.price.min.calculated}
              loading={loading}
            />
          ) : undefined}
          <Vicinity vicinity={property.vicinity} loading={loading} />
        </div>
        {!props.hideHelpForm ? (
          <div className={classes.helpForm}>
            <LetUsHelpYouForm
              source={"Single Property Page - " + "single property"}
            />
          </div>
        ) : undefined}
      </div>
      {!props.hideFeaturedProperties ? (
        <FeaturedProperties featuredProperties={featuredProperties} />
      ) : undefined}
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    singleProperty: state.singleProperty,
  };
}

const mapDispatchToProps = {
  fetchSingleProperty,
};

// export default SPPContainer;

export default connect(mapStateToProps, mapDispatchToProps)(SPPContainer);
